<!-- Notification -->
<template>
    <div>
        <!-- // * CONTENT TITLE (GENERIC) -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <v-icon v-if="form.priority === 'success'" class="iconbackground display-1 success--text icons8-circle"></v-icon>
                    <v-icon v-if="form.priority === 'error'" class="iconbackground display-1 warning--text icons8-circle"></v-icon>
                    <v-icon v-if="form.priority === 'warning'" class="iconbackground display-1 warning--text icons8-circle"></v-icon>
                    <v-icon v-if="form.priority === 'info'" class="iconbackground display-1 grey--text text--lighten-1 icons8-circle"></v-icon>

                    <span v-if="form.name === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form.name }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <uploadFilesButton v-show="formMode === 'New' || formMode === 'Edit'" :allowedTypes="'.png'" :buttonText="$t(`buttons.addPhoto`)"/>
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT (CUSTOM) -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU (CUSTOM) -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>
                        </v-tabs>
                        <!-- // * TABS ITEMS (CUSTOM) -->                            
                        <v-tabs-items v-model="tabs" class="appbackground">
                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-4 ma-0" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION (GENERIC) -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>                                                
                                                <v-divider class="my-4"/>
                                            </v-col>                                            
                                            <!-- // * ACTION BAR (CUSTOM) -->
                                            <v-col class="pa-0 d-flex pl-3 pr-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t(`buttons.destroy`)" v-if="formMode !== 'New' && form.delete !== undefined && ['DA'].includes(GET_currentUser.userLevel)"  icon="icons8-fire" type="purple"  class="mr-1" @click.native="destroyItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>                                                
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined && ['DA'].includes(GET_currentUser.userLevel)" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="saveItem()" showlabel="xlOnly" />                                                
                                                <appbutton :label="$t(`buttons.submit`)" v-if="form.concernStatus !== 'PENDING' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-email-send" type="info"  class="mr-0" @click.native="updateItemStatus('PENDING')" showlabel="xlOnly" />                                                
                                            </v-col>                    
                                        </v-row>
                                        <!-- // * FORM -->  
                                        <v-row class="mt-2 px-2" no-gutters>
                                            <!-- NAME -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field :label="$t(`fields.name`)" v-model="form.name" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                            </v-col>
                                            <!-- CATEGORY -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field :label="$t(`fields.category`)" v-model="form.category" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                            </v-col>
                                            <!-- PRIORITIES -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-select :label="$t(`fields.priority`)" v-model="form.priority" :items="priorities" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                    <template v-slot:item="data">
                                                        {{ data.item }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item }}
                                                    </template>                                    
                                                </v-select>
                                            </v-col>                                              
                                            <!-- TYPES -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-select :label="$t(`fields.type`)" v-model="form.type" :items="types" multiple filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                </v-select>
                                            </v-col>                                              
                                            <!-- LINK TEXT -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12 \r">
                                                <v-text-field :label="$t(`fields.linkText`)" v-model="form.linkText" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                            </v-col>          
                                            <!-- LINK -->   
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-text-field :label="$t(`fields.link`)" v-model="form.link" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                            </v-col>     
                                            <!-- DESCRIPTION -->                                                                       
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-textarea color="black"  :label="$t(`fields.description`)" v-model="form.description" filled hide-details :background-color="formBackground" auto-grow  rows="1" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-textarea>
                                            </v-col>
                                          
                                            <!-- SENDER -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6">
                                                <v-autocomplete color="black"  chips :label="$t(`fields.sender`)" v-model="form.sender" :items="computedUsers" item-text="userName" return-object  filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                    <template v-slot:item="data">
                                                        {{ data.item.userName }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.userName }}
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <!-- RECIPIENT -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6">
                                                <v-autocomplete color="black"  chips :label="$t(`fields.recipient`)" v-model="form.recipient" :items="computedUsers" item-text="userName" return-object  filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                    <template v-slot:item="data">
                                                        {{ data.item.userName }}<br />
                                                        <span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
                                                        <span v-if="data.item.userStatus === 'PENDING'" class="caption grey--text font-weight-bold pl-1">(PENDING)</span>
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.userName }}<br />
                                                        <span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>                                            
                                            <!-- READ -->                                                                       
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-text-field :label="$t(`fields.read`)" v-model="form.read" filled hide-details :background-color="formBackground" auto-grow  rows="1" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                                <v-btn @click="form.read = null">Null Read</v-btn>
                                            </v-col>
                                        </v-row>
                                        <!-- <pre>{{ form }}</pre> -->
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapActions  } from 'vuex'; // Map the Getters from the Vuex Store
    export default {
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'notifications',
            collectionTitle: 'Notifications',
            collectionItem: 'notification',
            collectionItemTitle: 'Notification',
            langPath: 'notifications.notification',
            tabs: 'notification',
            // * FORM RELATED
            form: {
                // id: '', // all users manual entry // TODO NOT SURE IF THIS IS REQUIRED
                name: '', // name of notification
                category: '', // category of notification
                description: '', // description of notification
                type: '',
                link: '',
                linkText: '',
                sender: '', // user id of person reporting notification
                recipient: '', // user id of ther person responsible for the notification
                read: null
            },
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',
            types: ['App', 'Email'], // Populated by Lookup Values
            priorities: ['warning', 'success', 'info', 'error'],
            users: []
           
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_lookupValues: 'GET_lookupValues', // Get Lookup Values
                GET_openItem: 'GET_openNotification', // Get Open Notification Data
                GET_organisations: 'GET_organisations', // Get Organisations
                GET_sites: 'GET_sites', // Get Sites,
                GET_projects: 'GET_projects', // Get Projects,
                GET_photoUploadResult: 'photoUpload_store/GET_photoUploadResult', // GET PhotoUpload Result
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_help: 'GET_help'                           
            }),
            computedUsers() {
                return this.users;
            },
                   
            // DOC LINK (GENERIC) - REQUIRED FOR DOCUMENT UPLOAD
            docLink() {
                var t = this;
                return ({ collection: t.collection, documentId: t.form.id })
            },
        },   
        // * WATCH
        watch: {
             // GET CONFIRMATION RESULT (CUSTOM)
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === 'notifications') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteDocumentResult = await t.MIX_deleteDocument ('notifications', t.GET_confirmBoxResult.data.id);
                            var deleteLinkedResult = await t.MIX_deleteLinked (['files', 'comments'], t.GET_confirmBoxResult.data.id);
                            if ((deleteDocumentResult.code === 1) && (deleteLinkedResult.code === 1)) {
                                var comment = {}
                                comment.comment = `${t.collectionItemTitle} Deleted` 
                                comment.docLink = {},
                                comment.docLink.collection = 'notifications';
                                comment.docLink.documentId = t.GET_confirmBoxResult.data.id;
                                comment.private = false;
                                await t.MIX_createDocument('comments', comment);
                                t.MIX_alert(1, `Notification and Photos Deleted`, deleteDocumentResult.data, null);
                                t.refreshItemView();                            
                            } else {
                                t.MIX_alert(-1, `Error Deleting Notification / Photos`, null, null);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'notifications/destroy') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var destroyDocumentResult = await t.MIX_destroyDocument ('notifications', t.GET_confirmBoxResult.data.id);
                            var destroyLinkedDocs = await t.MIX_destroyLinked (['files', 'comments'], t.GET_confirmBoxResult.data.id)
                            if ((destroyDocumentResult.code === 1) && (destroyLinkedDocs.code === 1)) {
                                t.MIX_alert(1, `Notification and Photos Destroyed`, destroyDocumentResult.data, null);
                                t.MIX_setPanelLayout(12, 0, false, '', '');
                            } else {
                                t.MIX_alert(-1, `Error Destroying Notification & Photos`, null, null);
                            }
                        }
                    // } else  if (t.GET_confirmBoxResult.data.collection === 'files') {
                    //     if (t.GET_confirmBoxResult.data.result === 'YES') {
                    //         var deleteFileRecord = await t.MIX_destroyDocument('files', t.GET_confirmBoxResult.data.id);
                    //         if (deleteFileRecord.code === 1){
                    //             await t.MIX_updateDocumentFieldsById ('documents', t.form.id, { fileData: null } )
                    //             t.MIX_alert(1, `File Deleted`, deleteFileRecord.data, null);
                    //             setTimeout(function() {
                    //                 t.refreshItemView();                                      
                    //                 t.MIX_setPanelLayout(6, 6, true, 'Document', 'document');
                    //             }, 1000)
                    //         } else {
                    //             t.MIX_alert(-1, `ERROR Deleting Document & File`, null, deleteFileRecord.error);
                    //         }
                    //     }
                    } else if (t.GET_confirmBoxResult.data.collection === 'comments') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Comment Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Comment', null, deleteResult.error);
                            }
                        }                                    
                    } else {
                        // Do nothing
                    }
                }, deep: true
            },        
            GET_photoUploadResult: {
                handler: async function() {
                    var photoUploadResult = this.GET_photoUploadResult;
                    if (JSON.stringify(photoUploadResult) !== '{}') {
                        var index = this.form.files.findIndex(file => file === photoUploadResult.id)
                        if (index === -1) {
                            this.form.files.push (photoUploadResult.id);
                            var updatePhotosResult = await this.MIX_updateDocumentFieldsById ('notifications', this.form.id, { files: this.form.files } )
                           // console.log('updatePhotosResult : ' + JSON.stringify(updatePhotosResult, null, 2))
                            if (updatePhotosResult.code === 1) {
                                this.MIX_alert(1, 'Photo Added', updatePhotosResult.data, null);
                                //this.getFiles();
                            } else {
                                this.MIX_alert(-1, 'Error Adding Photo', null, updatePhotosResult.error);
                            }
                        }
                    }
                }, deep: true
            }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openNotification'}),            
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[name]}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM (GENERIC)
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New': 
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }              
                return;
            },
            // EDIT ITEM (GENERIC)
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM (GENERIC)
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.refreshItemView();  
                t.closeRightPanel();      
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // SAVE ITEM (GENERIC)
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // UPDATE ITEM STATUS
            updateItemStatus: async function(status) {
                var t = this;
                // console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                // console.log('updateResult.code = ' + updateResult.code)
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error); 
                }
            },
            // REFRESH ITEM VIEW
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`, 
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[name]}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
            // UNDELETE ITEM METHOD
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    var unDeleteLinkedResult = await t.MIX_undeleteLinked (['files','comments'],  t.form.id)                    
                    if (unDeleteLinkedResult.code === 1) {
                        var comment = {}
                        comment.comment = `${t.collectionItemTitle} Restored` 
                        comment.docLink = {},
                        comment.docLink.collection = 'notifications';
                        comment.docLink.documentId = t.form.id;
                        comment.private = false;
                        await t.MIX_createDocument('comments', comment);
                        t.MIX_alert(1, `${t.collectionItemTitle} Restored`, unDeleteLinkedResult.data, null);
                        t.refreshItemView();                            
                    } else {
                        t.MIX_alert(-1, `Error Restoring File Record`, null, unDeleteLinkedResult.error);
                    }
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                    // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },
            // DESTROY ITEM METHOD (CUSTOM)
            destroyItem: async function() {
                var t = this
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'notifications/destroy',
                        id: t.form.id,
                        title: `Destroy Notification`, 
                        description: `Are you sure you want to destroy the notification: <br /><strong>${t.form.name}</strong>?`, 
                        width: '300',
                        height: '300',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )     
            },
            // calculateLength: function(arr) {
            //     if ((arr !== []) && (arr !== null) && (arr !== undefined)) {
            //         return arr.length;
            //     } else {
            //         return 0;
            //     }
            // },
            // GET COMMENTS METHOD (GENERIC)
            getComments: async function (openItem) {
                var t = this;
                if (JSON.stringify(openItem.data) !== '{}') {
                    t.$firebase.db.collection('comments').where("docLink.documentId", "==", openItem.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.commentsTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.commentsTableData.push(document);
                                } else if (t.showDeletedComments) {
                                     t.commentsTableData.push(document);
                                } else {
                                    // Do not Show Notice
                                }
                            });
                    });
                }
            },
            // DELETE COMMENT METHOD (GENERIC)
            deleteComment: function (item) {
                this.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'comments',
                        id: item.id,
                        title: 'Delete Comment', 
                        description: `Are you sure you want to delete comment: <strong>${item.comment}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },

            // Get Users
            getUsers: async function() {
                var t = this;
                t.$firebase.db.collection('users')
                    .onSnapshot(function(querySnapshot) {
                        t.users = [];
                        querySnapshot.forEach(function(doc) {
                            var document = {}
                            document.userId = doc.id;
                            document.userEmail = doc.data().userEmail;
                            document.userName = doc.data().userName;
                            document.organisationName = doc.data().organisation.organisationName;
                            document.organisationId = doc.data().organisation.organisationId;
                            if (!document.hasOwnProperty('delete')) {
                                t.users.push(document);
                            } else if (t.showDeletedFiles) {
                                 t.users.push(document);
                            } else {
                                // Do not Show Notice
                            }
                        });
                    })
            },
            // Open Photo
            openPhoto(index) {
                var t = this;
                var payload = {}
                payload.title = t.form.name;
                payload.index = index;
                payload.collection = 'notifications';
                payload.id = t.form.id;
                payload.photos = t.files;
                var width, height
               // console.log('t.$vuetify.breakpoint.name = ' + t.$vuetify.breakpoint.name)
                switch (true) {
                    case (t.$vuetify.breakpoint.name === 'xs'): width='300'; height="300"; break;
                    case (t.$vuetify.breakpoint.name === 'sm'): width='300'; height="300"; break;
                    default: width='600'; height="580"; break;
                }
                payload.width = width;
                payload.height = height; 
                t.MIX_photoViewer (payload);
                t.MIX_puDialog (true, 'photoviewer', width, (parseFloat(height) + 88).toString())
                
            },
            // DELETE PHOTO (GENERIC)
            deletePhoto: async function (fileId) {
                var t = this;
                var deleteFileResult = await t.MIX_deleteDocument('files', fileId);
                if (deleteFileResult.code === 1) {
                    t.MIX_alert(1, 'Photo Deleted', deleteFileResult.data, null); // Send Success Alert to Notification
                } else {
                    t.MIX_alert(-1, 'Error Deleting Photo', null, deleteFileResult.error); // Send Error Alert to Notification
                }                
            },
            // UNDELETE PHOTO (GENERIC)
            undeletePhoto: async function (fileId) {
                var t = this;
                var undeleteFileResult = await t.MIX_undeleteDocument('files', fileId);
                if (undeleteFileResult.code === 1) {
                    t.MIX_alert(1, 'Photo Restored', undeleteFileResult.data, null); // Send Success Alert to Notification
                } else {
                    t.MIX_alert(-1, 'Error Restoring Photo', null, undeleteFileResult.error); // Send Error Alert to Notification
                }                
            },

            // CALCULATE ARRAY LENGTH
            calculateArrayLength(array) {
                return array.length;
            }
        },
        async mounted() {
            var t = this;            
            // * LOOKUP RELATED MOUNTED
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            // * GET USERS
            t.getUsers();
            
            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            t.formMode = openItem.process; // Show Form in View Mode
            if (openItem.process === 'New') { 
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details    
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                //t.getFiles(openItem); // GET FILES
                t.getComments(openItem);
            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title

            // t.getFiles(); // GET FILES
            // // * SET PHOTO UPLOAD DEFAULTS
            // if (t.form.id !== '') {
            //    // console.log('form.id = ' + t.form.id)
            //     t.MIX_photoUpload({type: 'notifications', typeId: t.form.id, allowedTypes: 'image/*', folder: 'concerntest' })
            // }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title

}
    }
</script>

<style scoped>
  .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
    .v-tabs-items{
        width: 100% !important;
        height: 100% !important;
    }
    .v-window-item {
        height: calc(100vh - 170px); 
        overflow-y: auto;
    }
    .v-menu__content {
        box-shadow: none !important;
    }
.fade-in-enter-active {
  transition: all 0.5s ease;
}

.fade-in-leave-active {
  transition: all 0.5s ease;
}

.fade-in-enter, .fade-in-leave-to {
  position: absolute; /* add for smooth transition between elements */
  opacity: 0;
}
    /* v-menu__content theme--light menuable__content__active */
</style>